// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type CreateEpmMasterFunctionalityMutationVariables = Types.Exact<{
  input: Types.CreateEpmMasterFunctionalityInput;
}>;

export type CreateEpmMasterFunctionalityMutation = { __typename?: 'Mutation' } & {
  createEpmMasterFunctionality: { __typename?: 'EpmMasterFunctionalityOutput' } & Pick<
    Types.EpmMasterFunctionalityOutput,
    'id'
  >;
};

export const CreateEpmMasterFunctionalityDocument = /*#__PURE__*/ gql`
    mutation createEpmMasterFunctionality($input: CreateEpmMasterFunctionalityInput!) {
  createEpmMasterFunctionality(input: $input) {
    id
  }
}
    `;
export type CreateEpmMasterFunctionalityMutationFn = Apollo.MutationFunction<
  CreateEpmMasterFunctionalityMutation,
  CreateEpmMasterFunctionalityMutationVariables
>;

/**
 * __useCreateEpmMasterFunctionalityMutation__
 *
 * To run a mutation, you first call `useCreateEpmMasterFunctionalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEpmMasterFunctionalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEpmMasterFunctionalityMutation, { data, loading, error }] = useCreateEpmMasterFunctionalityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEpmMasterFunctionalityMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateEpmMasterFunctionalityMutation,
    CreateEpmMasterFunctionalityMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateEpmMasterFunctionalityMutation, CreateEpmMasterFunctionalityMutationVariables>(
    CreateEpmMasterFunctionalityDocument,
    options,
  );
}
export type CreateEpmMasterFunctionalityMutationHookResult = ReturnType<typeof useCreateEpmMasterFunctionalityMutation>;
export type CreateEpmMasterFunctionalityMutationOptions = Apollo.BaseMutationOptions<
  CreateEpmMasterFunctionalityMutation,
  CreateEpmMasterFunctionalityMutationVariables
>;
